import * as React from "react"

import { cn } from "@/lib/utils"

export const fcTextareaClass = "flex min-h-[80px] w-full rounded-lg border border-fc-stroke-2 bg-fc-well px-3 py-2 text-[13px] text-white transition-[border-color,box-shadow] duration-150 placeholder:text-white/30 focus-visible:outline-none focus-visible:border-fc-accent/70 focus-visible:shadow-fc-focus disabled:cursor-not-allowed disabled:opacity-50"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(fcTextareaClass, className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
